import { render, staticRenderFns } from "./VerifyEmployeeRegistrationDialogStep4.vue?vue&type=template&id=36885f0f&scoped=true"
import script from "./VerifyEmployeeRegistrationDialogStep4.vue?vue&type=script&lang=js"
export * from "./VerifyEmployeeRegistrationDialogStep4.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmployeeRegistrationDialogStep4.vue?vue&type=style&index=0&id=36885f0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36885f0f",
  null
  
)

export default component.exports